import { build } from "../../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/profile/dispatcher-subaccounts",
		component: lazy(() => import("./CarrierSubAccountsPage")),
	},
]);
